module.exports = __webpack_public_path__ + "static/media/thirdfloor.dee0c913.png";